import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

export const GlobalSearchTooltip = ({
  children,
  ...props
}: Omit<TooltipProps, "arrow" | "placement" | "componentsProps">) => (
  <Tooltip
    arrow
    placement="top"
    componentsProps={{ tooltip: { sx: { fontSize: "13px" } } }}
    {...props}
  >
    {children}
  </Tooltip>
);
